import styled from 'styled-components';

const WrapperStyled = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 48px 0px;
  border-top: 1px #c9cfd7 solid;
  width: 100%;
`;

const BlocksStyled = styled(WrapperStyled)`
  align-items: space-between;
  border-top: none;
  flex-direction: row;
  flex-wrap: wrap;
  margin: 0px 0px 32px;
  padding: 0px;

  @media (min-width: 769px) {
    align-items: space-between;
    border-top: none;
    flex-wrap: wrap;
  }

  > div {
    > svg {
      margin-right: 5px;
    }
  }
`;
const ParItemBlockStyled = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;

  @media (min-width: 769px) {
    flex-direction: row;
    height: 76px;
  }
`;

const ItemBlockStyled = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  margin: 22px;
  max-width: 150px;
  height: 76px;

  @media (min-width: 769px) {
    margin: 0px 22px;
  }
`;

const SvgHeaderWrapperStyled = styled.div`
  margin: 0px 0px 32px;
`;

export {
  WrapperStyled,
  BlocksStyled,
  SvgHeaderWrapperStyled,
  ItemBlockStyled,
  ParItemBlockStyled,
};
